// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"47b1798151676d34af3e","655":"7ee6c0a44c8023cb3205"}[chunkId] + ".js";
};